module.exports = __webpack_public_path__ + "img/np.64b7abbc.svg";